import React from "react";

import {ENTITY_TYPE} from "../../../api/constants";
import InsertPopoverHint from "./popover-hint";

export default class InsertPopoverOptions extends React.Component {

    // handleHoverOn = (info) => {this.hint.setMessage(info)}
    // handleHoverOff = () => {this.hint.setMessage(null)}

    renderOption = (icon, label, info, callback) => {
        return (
            <div className="option with-icon"
                 onClick={()=>{this.props.hidePopover(); callback()}}
                 /*onMouseEnter={this.handleHoverOn.bind(this, info)}
                 onMouseLeave={this.handleHoverOff}*/>
                <div className={Classes("ico", icon)}/>
                <div className="label">{label}</div>
            </div>
        )
    }

    onInsertUserMention = () => {this.props.menuParams.addMention()}
    onInsertTaskLink =    () => {this.props.menuParams.addLinkTask()}
    onInsertNoteLink =    () => {this.props.menuParams.addLinkNote()}

    onInsertImage =       () => {this.props.menuParams.onRequestSource(ENTITY_TYPE.IMAGE)}
    onInsertLink =        () => {this.props.menuParams.onRequestSource(ENTITY_TYPE.LINK)}
    onInsertLine =        () => {this.props.menuParams.addHorizontalLine()}
    onInsertNewLine =     () => {this.props.menuParams.addBR()}

    render() {


        return (
            <div className="ui5-popover-menu with-help" style={{width:180}}>
                {this.renderOption('editor-i5-mention',          'User mention',     'Press slash to activate insert menu',   this.onInsertUserMention)}
                {this.renderOption('i5-task',              'Link a task',      'Press slash to activate insert menu',   this.onInsertTaskLink)}
                {this.renderOption('i5-sticky-note',             'Link a note',      'Press slash to activate insert menu',   this.onInsertNoteLink)}

                <div className='separator'/>

                {this.renderOption('editor-i5-image',             'Image',            null,                                    this.onInsertImage)}
                {this.renderOption('editor-i5-link',              'Insert web link',  'Press slash to activate insert menu',   this.onInsertLink)}
                {this.renderOption('editor-i5-line',   'Line',             null,                                    this.onInsertLine)}
                {this.renderOption('editor-i5-page-break',        'New line',         null,                                    this.onInsertNewLine)}

                <InsertPopoverHint ref={r=>this.hint = r} defaultMessage="Press / to activate insert menu from the editor"/>
            </div>
        );
    }
}